<script>
	// @ts-nocheck

	import { onMount, tick } from 'svelte';
	import { DialogNew, Icon } from '@shopboxai/sb-portal-components';
	import { clientID } from '../../../utils/utils.js';
	import { saveGridConfig } from '../../../utils/api.js';
	import { tour } from '../../../utils/tour.js';
	export let data = {};
	let mounted;
	let isMobileView = false;

	const nextTourStep = (id) => {
		if (tour.isActive()) {
			tour.getCurrentStep().hide();
			setTimeout(() => {
				tour.show(id, true);
			}, 1000);
		}
	};
	const saveConfig = async () => {
		console.log('save config before preview');
		mounted = false;
		await tick();
		console.log(data);
		await saveGridConfig(
			data.id,
			data.name,
			data.css,
			true,
			data.styleOptions,
			data.customProducts
		);
		await tick();
		mounted = true;
	};

	const getIframeHTML = (data, mobile = false) => {
		return `<html><head>	<script src="https://grid.shopbox.ai/sbgrid.min.js"><\/script></head><body style="display:flex;justify-content:center;"> <shopbox-grid id='${
			data?.id
		}' cid='${$clientID}' currency='${
			data.currency || 'EUR'
		}' preview='true' mobilepreview='${mobile}' /></body></html>`;
	};
</script>

<svelte:head />
<DialogNew on:submit on:close on:open={saveConfig} maxWidth="1400px" customClass="preview-dialog">
	<div slot="header">Preview</div>

	<button
		class="primary tour-step-12"
		slot="primary-action"
		on:click={() => tour.getCurrentStep().hide()}
	>
		Save & Publish
	</button>

	<div slot="content" style="height:100%;">
		<ul class="device-switcher">
			<li
				on:click={() => (isMobileView = !isMobileView)}
				on:keypress={() => (isMobileView = !isMobileView)}
				class:active-device={!isMobileView}
			>
				<Icon name="desktop" /> Desktop View
			</li>
			<li
				on:click={() => (isMobileView = !isMobileView)}
				on:keypress={() => (isMobileView = !isMobileView)}
				class:active-device={isMobileView}
			>
				<Icon name="mobile" /> Mobile View
			</li>
		</ul>
		<div class="device-wrapper">
			{#if mounted}
				<iframe
					title="device"
					class:mobile={isMobileView}
					srcdoc={getIframeHTML(data, isMobileView)}
				/>
			{/if}
		</div>
	</div>
	<button
		slot="toggle"
		class="secondary dialog-toggle tour-step-11"
		on:click={() => nextTourStep(11)}
		><Icon name="desktop" /> Preview & Publish
	</button>
</DialogNew>

<style>
	:global(.preview-dialog header) {
		margin-bottom: unset;
		border-bottom: none;
		padding: 0.5em 0;
	}
	:global(.preview-dialog .dialog) {
		height: 90vh;
	}
	:global(.preview-dialog form),
	:global(.preview-dialog .device-wrapper) {
		height: 100%;
	}
	.secondary {
		border: 1px solid;
	}

	iframe {
		height: calc(100% - 40px);
		border: 1px solid var(--br-c);
		width: 100%;
		max-width: 100%;
		margin: 1em auto;
		padding: 0.5em;
	}
	.mobile {
		max-width: 375px;
	}

	.device-wrapper {
		display: flex;
		justify-content: center;
	}
	.dialog-toggle {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
	}

	.dialog-toggle :global(svg path) {
		stroke: var(--h-c);
	}

	:global(.preview-dialog) {
		z-index: 2147483647;
	}

	.device-switcher {
		list-style: none;
		display: inline-flex;
		background-color: var(--bg-c);
		padding: 6px;
		gap: 1em;
		border-radius: 3px;
	}
	.device-switcher li {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 4px;
		border-radius: 3px;
		padding: 4px 12px;
		border-radius: 4px;
		font-size: 14px;
		color: var(--t-c-l);
		line-height: 1;
		cursor: pointer;
	}
	.device-switcher li.active-device {
		box-shadow: 0px 0px 4px -2px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.08);
		background-color: #fff;
		color: var(--p-c);
	}
	.device-switcher li.active-device :global(path) {
		stroke: var(--p-c);
	}
</style>
